import React, { useEffect } from 'react';
import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";
import PropTypes from "prop-types";
import messages from "../messages";

const OccupationField = (props) => {
  const { formatMessage } = useIntl();
  const {
    onChangeHandler,
    handleErrorChange,
    onFocusHandler,
    errorMessage,
    selectedOccupation,
  } = props;
  
  const handleOnChange = (value) => {
    onChangeHandler({target: { name: 'occupation', value: value } } )
  }
  useEffect(() => {
    if (props.errorMessage === undefined){
      return
    }
    if (props.errorMessage !== "") {
      handleOnChange("");
    }
    
  }, [errorMessage]);
  return (
    <div className="mb-4">
      <AuthFormAutosuggest
        floatingLabel={`${formatMessage(messages["occupation"])} *`}
        aria-label="form autosuggest"
        name="occupation"
        onFocus={(e) => onFocusHandler(e)}
        value={ selectedOccupation}
        className={classNames({ "form-field-error": props.errorMessage })}
        onChange={(value) => handleOnChange(value)}
      >
        {[
          "teacher",
          "pupil",
          "student",
          "other",
        ].map((occupation) => (
          <FormAutosuggestOption key={occupation} id={occupation}>
            {formatMessage(messages[`${occupation}`])}
          </FormAutosuggestOption>
        ))}
      </AuthFormAutosuggest>
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="occupation"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default OccupationField;
